import { graphql, compose } from 'react-apollo';

import gql from 'graphql-tag';

export const SURVEY_RESPONDENT_QUERY = gql`
  query($accountId: ID!, $surveyId: ID!) {
    account(id: $accountId) {
      id
      surveyRespondent(id: $surveyId) {
        id
        locale
        status
        token
        previewInviteUrl
        previewReminderUrl
        respondent {
          id
          firstName
          lastName
        }
        survey {
          id
          name
        }
        createdOn
        invitedOn
        remindedOn
        declinedOn
        updatedOn
        expiredOn
        submittedOn
        startedOn
      }
    }
  }
`;
const SurveyRespondentDetailQuery = graphql(SURVEY_RESPONDENT_QUERY, {
  options: ({ match }) => {
    const { surveyRespondentId, aid } = match.params;
    return {
      variables: {
        surveyId: surveyRespondentId,
        accountId: aid,
      },
    };
  },
  name: 'SurveyRespondentDetail',
});
export default compose(SurveyRespondentDetailQuery);
